import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { Project, Result } from '../../models/projects.interface';
import { ProjectCycleDetails, ProjectDetails } from '../../../features/user-dashboard/models/project-details.interface';


@Injectable({
  providedIn: 'root',
})
export class ProjectsService {
  private readonly http=inject(HttpClient)

  getProjects():Observable<Project>{
  return this.http.get<Project>(environment.baseUrl + `projects/`);
  }
  
   getProjectDetails(id: number): Observable<ProjectDetails> {
    return this.http.get<ProjectDetails>(environment.baseUrl + `projects/${id}/`);
  }
  
  getCycleDetails(projectId: number, cycleId: number) {
  return this.http.get<ProjectCycleDetails>(
    `${environment.baseUrl}projects/${projectId}/cycles/${cycleId}/`
  );
}

}
